import {
	Box,
	CasperIconComponent,
	Flex,
	MenuIcon,
	MessageIcon,
	ModuleNotificationCenterIcon,
	ModuleScheduleIcon,
	NavigationList,
	NavigationListButton,
	Text,
	TimeIcon,
} from "@caspeco/casper-ui-library";
import {
	ThemeColorVariable,
	ThemeFontSizeVariable,
	ThemeRadiusVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { NavLink, useLocation } from "react-router";
import { MyPagesRoutes } from "../../types/routes";
import { useTranslation } from "react-i18next";
import { SIZE_LIMIT } from "../../constants";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../../types/query-key-enum";
import { getUnreadMessages } from "../../services/api/messages-api";
import { useUserContext } from "../../hooks/use-user-context";
import "./nav.css";
import { useAppContext } from "../../hooks/use-app-context";
//import { useSystemNewsCountQuery } from "../../pages/home/hooks/use-system-news-count-query";

const NavBar = () => {
	const { t } = useTranslation();
	const { systems } = useUserContext();
	const { safeArea } = useAppContext();
	const isDesktopSize = window.innerWidth > SIZE_LIMIT;
	const location = useLocation(); // Get current location

	const { data: unreadMessageCount } = useQuery({
		queryKey: [QueryKeys.MessageUnread],
		queryFn: () => getUnreadMessages(systems.map((s) => s.name)),
	});

	//const systemNewsQueries = useSystemNewsCountQuery(systems);
	//const systemNewsCount = systemNewsQueries.map((q) => q.data || 0).reduce((acc, curr) => acc + curr, 0);

	return (
		<NavigationList
			w="100%"
			maxWidth={"100vw"}
			bg={ThemeColorVariable.Surface}
			borderBottomRadius={isDesktopSize ? ThemeRadiusVariable.Large : ThemeRadiusVariable.None}
			paddingBottom={safeArea.bottomAsPx()}
		>
			<Flex align="center" justify="space-around">
				<NavBarLinkItem
					route={MyPagesRoutes.News}
					text={t("news")}
					icon={ModuleNotificationCenterIcon}
					//notificationCounter={systemNewsCount}
					testId="nav-news-link"
				/>
				<NavBarLinkItem
					route={MyPagesRoutes.TimeReport}
					text={t("timereport")}
					icon={TimeIcon}
					testId="nav-timereport-link"
				/>
				<NavBarLinkItem
					route={MyPagesRoutes.Schedule}
					text={t("schedule")}
					icon={ModuleScheduleIcon}
					isActive={[`/${MyPagesRoutes.Schedule}`, `/${MyPagesRoutes.Colleagues}`].some((path) =>
						location.pathname.startsWith(path),
					)}
					testId="nav-schedule-link"
				/>
				<NavBarLinkItem
					route={MyPagesRoutes.Messages}
					text={t("messages")}
					icon={MessageIcon}
					notificationCounter={unreadMessageCount}
					testId="nav-messages-link"
				/>
				<NavBarLinkItem
					route={MyPagesRoutes.Menu}
					text={t("choice_menu")}
					isActive={[
						`/${MyPagesRoutes.Clock}`,
						`/${MyPagesRoutes.Tip}`,
						`/${MyPagesRoutes.Salary}`,
						`/${MyPagesRoutes.Feedback}`,
						`/${MyPagesRoutes.Documents}`,
						`/${MyPagesRoutes.Profile}`,
						`/${MyPagesRoutes.PeriodOverview}`,
					].includes(location.pathname)}
					icon={MenuIcon}
					testId="nav-menu-link"
				/>
			</Flex>
		</NavigationList>
	);
};

interface INavBarItemProps {
	route: string;
	icon: CasperIconComponent;
	text: string;
	notificationCounter?: number;
	isActive?: boolean;
	testId?: string;
}

const NavBarLinkItem = (props: INavBarItemProps) => {
	const location = useLocation(); // Get current location

	const isActive = props.isActive !== undefined ? props.isActive : location.pathname === props.route;

	return (
		<Box w="20%" data-testid={props.testId}>
			<NavigationListButton className="hover-override">
				<NavLink to={props.route}>
					{({ isActive: defaultIsActive }) => (
						<Flex align={"center"} justify={"center"} direction={"column"}>
							<Flex
								justify="center"
								align="center"
								h="40px"
								w="40px"
								bg={defaultIsActive || isActive ? ThemeColorVariable.Primary : ""}
								borderRadius="50%"
							>
								{props.notificationCounter && props.notificationCounter > 0 ? (
									<Box
										position={"absolute"}
										top={"0.4rem"}
										left={"55%"}
										bg={ThemeColorVariable.Secondary}
										borderRadius={ThemeRadiusVariable.Large}
										fontSize={ThemeFontSizeVariable.Small}
										lineHeight={ThemeSpaceVariable.Small}
										padding={ThemeSpaceVariable.Small}
										minW={ThemeFontSizeVariable.XLarge}
										data-testid={"nav-unread-badge-" + props.route}
									>
										{props.notificationCounter > 999 ? "999+" : props.notificationCounter}
									</Box>
								) : null}
								<props.icon
									color={
										defaultIsActive || isActive ? ThemeColorVariable.OnPrimary : ThemeColorVariable.OnSurface
									}
									borderRadius={ThemeRadiusVariable.XLarge}
									fontSize="20px"
								/>
							</Flex>
							<Text fontSize={ThemeFontSizeVariable.XSmall}>{props.text}</Text>
						</Flex>
					)}
				</NavLink>
			</NavigationListButton>
		</Box>
	);
};

export default NavBar;
